module.exports = __webpack_public_path__ + "1d6f608d64832b9ef80ed5eabeaad494.svg";